import { IntlShape } from 'react-intl';

const translationMap: Record<string, string> = {
  // Phase/Studio
  'All Total': 'table_allTotal',
  'Phase 3 Total': 'table_phase3Total',
  'Phase 2 Total': 'table_phase2Total',
  'Phase 1 Total': 'table_phase1Total',
  'Function Total': 'table_functionTotal',

  // Publishing/Studio HQ
  'Publishing - HQ': 'table_publishing_hq',
  'Studio - HQ': 'table_studio_hq',
  'Central & Others': 'table_central_others',

  // Project
  'Mature': 'table_mature',
  'Long-Tail': 'table_longtail',
  'Newly Online': 'table_newly_online',
  'Incubation': 'table_incubation',

  // IEGG Overall Income Dashboard (Business Overview > Overall Financial)
  'Gross Revenue Total': 'table_gross_revenue_total',
  'Profit Total': 'table_profit_total',

  // Financial Terms
  'Dev Cost': 'dev_cost',
  'Mkt Cost': 'mkt_cost',
  'Other Cost': 'other_cost',
  'Total Dev Cost': 'total_dev_cost',
  'Revenue': 'net_revenue',
  'Cum. Profit / Break even': 'cum_profit_break_even',
  'RD': 'rd',
  'SM': 'sm',

  // Publishing Headcount
  'Publishing HC': 'publishing_hc',
  'Capability Box': 'capability_box',
  'Studios': 'subtitle_studios',
  'KPI': 'full_year_kpi_avg',
  'Y2 Live-Ops': 'y2_live_ops',
  'Y1(Include 6 months pre launch)': 'y1_include_6_months_pre_launch',
  'Production': 'production',
  'Pre-Production': 'pre_production',
  'Canceled': 'canceled',
};

export const localizeLabel = (text: string, formatMessage: IntlShape['formatMessage']) => {
  const key = translationMap[text];
  if (key) {
    return formatMessage({ id: `dbs_${key}` });
  }
  return text;
};